import { Component, OnInit } from '@angular/core';
import { IFilterComp, IFilterParams } from 'ag-grid-community';

@Component({
  selector: 'app-custom-filter',
  template: `
    <div class="container-div">
      <span>{{params.title}}</span>
     <div class="text-div"> {{params.text}}</div>
    </div>
  `,
  styles: [
    `
    span{
      font-weight:bold;
    }
    .container-div {
      width:auto;
      padding:10px;
    }
    .text-div{
      margin-top:10px;
      max-width:30vw;
    }
    `,
  ],
})
export class CustomFilterComponent implements IFilterComp {
  params!: any;
  filterValue: string = "";
  guiElement: HTMLElement | null = null;

  agInit(params: IFilterParams): void {

    this.params = params;
    console.log('params', params)
  }

  onFilterChange() {
    this.params.filterChangedCallback();
  }

  doesFilterPass(params: any): boolean {
    const fieldValue = params.data[this.params.colDef.field];
    // Null kontrolleri ekle
    if (fieldValue === null || fieldValue === undefined) {
      return this.filterValue === "";
    }
    return fieldValue
      .toString()
      .toLowerCase()
      .includes(this.filterValue.toLowerCase());
  }

  isFilterActive(): boolean {
    return this.filterValue !== "";
  }

  getModel() {
    return this.isFilterActive() ? { value: this.filterValue } : null;
  }

  setModel(model: any) {
    this.filterValue = model?.value || "";
  }

  getGui(): HTMLElement {
    // Bu method çağrıldığında DOM elementi döndür
    if (!this.guiElement) {
      this.guiElement = document.createElement("div");
    }
    return this.guiElement;
  }

  

  // Filtre temizleme metodu
  resetFilter() {
    this.filterValue = "";
    this.onFilterChange();
  }

  // Bileşen yok edildiğinde
  destroy() {
    // Temizlik işlemleri gerekirse
    this.guiElement = null;
  }
}